import * as React from "react";
import './App.css';

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Button from "@mui/material/Button";
import Fun from "./components/Fun";
import IconButton from "@mui/material/IconButton";
import Info from "./components/Info";
import Project from "./components/Project";
import {
  HashRouter as Router,
  Link as RouterLink,
  Routes,
} from "react-router-dom";
import { Route } from "react-router";
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import Work from "./components/Work";
import CssBaseline from '@mui/material/CssBaseline';

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

function App() {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  const [value, setValue] = React.useState("project");
  const handleClick = (event, newValue) => {
    console.log(event);
    console.log(newValue);
    setValue("fun");
  };
  return (
      <Box
      sx={{
        height: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        color: "text.primary",
        borderRadius: 1,
        p: 3,
      }}
      >
      <IconButton size="small" sx={{ ml: 2 }} component={RouterLink} to="/info">
        <Avatar
          sx={{ width: 32, height: 32 }}
          alt="Rosaline"
          src="assets/img/profile_update_small.JPG"
        />
      </IconButton>
      <Button sx={{ minWidth: 100 }} component={RouterLink} to="/project">
        Project
      </Button>
      <Button sx={{ minWidth: 100 }} component={RouterLink} to="/work">
        Work
      </Button>
      <Button sx={{ minWidth: 100 }} component={RouterLink} to="/fun">Fun</Button>
      <IconButton
        sx={{ ml: 1 }}
        onClick={colorMode.toggleColorMode}
        color="inherit"
      >
        {theme.palette.mode === "dark" ? (
          <Brightness7Icon />
        ) : (
          <Brightness4Icon />
        )}
      </IconButton>
    </Box>
  );
}

export default function ToggleColorMode() {
  const [mode, setMode] = React.useState("dark");

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            // palette values for light mode
            primary: {
              main: '#6b67c2'
            },
            text: {
              primary: '#6b67c2',
              secondary: '#331a7e',
            },
            background: {
              default: '#eff7ff',
              paper: '#eff7ff',
            },
          }
        : {
            primary: {
              main: "#ecffda",
            },
            text: {
                  primary: "#ecffda",
                  secondary: "#81bc5f",
            },
            background: {
              default: '#130424',
              paper: '#130424',

            },
          }),
    },
    typography: {
      fontSize: 18,
    }
  });

  const theme = React.useMemo(
    () => createTheme(getDesignTokens(mode)), [mode]);


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <App />
          <Box sx={{ mx: "auto", height: 10 }} />
          <Routes>
            <Route exact path="/" element={<Info />}></Route>
            <Route path="/body" element={<Project />}></Route>
            <Route path="/info" element={<Info />}></Route>
            <Route path="/work" element={<Work />}></Route>
            <Route path="/project" element={<Project />}></Route>
            <Route path="/fun" element={<Fun />}></Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
